import { supabase } from '../lib/supabase';

// supabase.functions.invoke() hides the response body on non-2xx statuses and only
// returns a generic "Edge Function returned a non-2xx status code" message. The real
// message sent by the function lives on error.context (the raw Response).
export const getFunctionErrorMessage = async (error, fallback = 'Something went wrong') => {
  try {
    const body = await error?.context?.json?.();
    if (body?.error) return body.error;
  } catch {
    // body was not JSON — fall through to the generic message
  }
  return error?.message || fallback;
};

const escapeLike = (value) => value.replace(/[\\%_]/g, '\\$&');

// Returns the portals (e.g. ['Parent', 'Host']) in which this email already has an account.
export const findEmailPortals = async (email) => {
  const pattern = escapeLike(email?.trim()?.toLowerCase() || '');
  if (!pattern) return [];

  const [parentRes, hostRes] = await Promise.all([
    supabase?.from('parent_profiles')?.select('id, is_admin')?.ilike('email', pattern)?.limit(1),
    supabase?.from('event_host_profiles')?.select('id')?.ilike('email', pattern)?.limit(1),
  ]);

  const portals = [];
  const parent = parentRes?.data?.[0];
  if (parent) portals.push(parent?.is_admin ? 'Admin' : 'Parent');
  if (hostRes?.data?.length > 0) portals.push('Host');
  return portals;
};

export const formatEmailTakenMessage = (portals) =>
  `This email is already registered in the ${portals.join(' and ')} portal${portals.length > 1 ? 's' : ''}. Please use a different email address.`;
